/* eslint-disable prefer-const */

let AXIOS = null; // must be initialized
let baseURL = null;
let config=  null;

export default {
  AXIOS,
  baseURL,
  config,
};
